import { Drawer, LinearProgress, makeStyles } from '@material-ui/core'
import deburr from 'lodash.deburr'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useLayoutEffect, useState } from 'react'

import searchIcon from '../../assets/images/search.svg'
import { getMovieTickets } from '../../services/ClubeApi'

function SoldMovieTickets(props) {
  const [data, setData] = useState([])
  const [query, setQuery] = useState('')
  const [loading, setLoading] = useState(false)
  const classes = useStyles()

  useLayoutEffect(() => {
    if (!props.info) {
      setData([])
      return
    }

    getData(props.info.id)
  }, [props.info])

  useLayoutEffect(() => {
    if (props.open) setQuery('')
  }, [props.open])

  const getData = async groupId => {
    setLoading(true)
    let data = await getMovieTickets(groupId)
    let grouped = data.reduce((accumulative, current) => {
      let key = `${current.clientGazetaId}@${current.updatedAt}`
      return {
        ...accumulative,
        [key]: {
          ...current,
          total: (accumulative[key]?.total || 0) + 1
        }
      }
    }, {})
    let sorted = Object.values(grouped).sort(
      (one, another) => new Date(another.updatedAt) - new Date(one.updatedAt)
    )
    setData(sorted)
    setLoading(false)
  }

  const handleQueryChange = e => setQuery(e.target.value)

  const queryRegexp = new RegExp(deburr(query), 'i')
  const finalData = data.filter(item => queryRegexp.test(deburr(item.ClientGazetum.name)))

  return (
    <Drawer
      anchor="right"
      open={props.open}
      onClose={props.onClose}
      classes={{
        paper: classes.paper
      }}
    >
      <h1 className={classes.title}>Ingressos vendidos</h1>
      {loading && <LinearProgress style={{ marginTop: 30 }} />}
      {!loading && (
        <>
          <div className={classes.row}>
            <input
              className={classes.search}
              value={query}
              onChange={handleQueryChange}
              placeholder="Buscar..."
            />
          </div>
          <table className={classes.table}>
            <colgroup>
              <col />
              <col className={classes.fitContent} />
              <col className={classes.fitContent} />
            </colgroup>
            <thead>
              <tr>
                <td>Usuário</td>
                <td>Qtde</td>
                <td>Valor unitário</td>
                <td>Data</td>
              </tr>
            </thead>
            <tbody>
              {finalData.map(item => (
                <tr key={item.id}>
                  <td>{item.ClientGazetum.name}</td>
                  <td>{item.total}</td>
                  <td>
                    {new Intl.NumberFormat('pt-br', {
                      style: 'currency',
                      currencyDisplay: 'symbol',
                      currency: 'BRL',
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2
                    }).format(item.paidValue)}
                  </td>
                  <td>{moment(item.updatedAt).format('L LT')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </Drawer>
  )
}

SoldMovieTickets.propTypes = {
  info: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}

const useStyles = makeStyles({
  paper: {
    padding: '45px'
  },
  title: {
    marginBottom: '35px',
    fontFamily: 'Matrice',
    fontSize: '24px',
    color: '#30287b'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: '35px'
  },
  search: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 190,
    height: 40,
    padding: '10px 15px',
    boxSizing: 'border-box',
    fontSize: '12px',
    color: '#30287b',
    background: `url(${searchIcon}) top right / auto 100% content-box no-repeat`,
    border: '2px solid #30287b'
  },
  table: {
    width: '100%',
    margin: '-10px 0',
    '& td': {
      padding: '10px 15px',
      fontWeight: '500',
      color: '#30287b',
      textAlign: 'center'
    },
    '& thead td': {
      fontSize: '14px',
      fontWeight: 700
    },
    '& tbody tr:hover td': {
      backgroundColor: '#ece5fe'
    },
    '& tbody td': {
      transition: 'background-color .1s ease'
    },
    '& tbody td:first-child': {
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4
    },
    '& tbody td:last-child': {
      borderTopRightRadius: 4,
      borderBottomRightRadius: 4
    }
  },
  fitContent: {
    width: 'fit-content'
  }
})

export default SoldMovieTickets
